'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchRemote = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchRemote = exports.SearchRemote = {
    // this is search ... need to adjust to use the category landing page endpoint
    fetchCategoryResults: function fetchCategoryResults(_ref) {
        var deployment = _ref.deployment,
            ids = _ref.ids,
            searchQuery = _ref.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var encodedParams = encodeURIComponent((0, _stringify2.default)(searchQuery));
            var encodedIds = encodeURIComponent((0, _stringify2.default)(ids));
            var request = (0, _helpers.makeGet)('<SEARCH-API>?ids=' + encodedIds + '&parameters=' + encodedParams, deployment, 'categoryweb');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchFacetsResults: function fetchSearchFacetsResults(_ref2) {
        var deployment = _ref2.deployment,
            searchQuery = _ref2.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<SEARCH-API>?parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery)), deployment, 'faceted');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchResults: function fetchSearchResults(_ref3) {
        var deployment = _ref3.deployment,
            searchQuery = _ref3.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<SEARCH-API>?parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery)), deployment, 'web');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/search.js
// module id = 6t9d
// module chunks = 57